import script from "./BigCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BigCard.vue?vue&type=script&setup=true&lang=ts"

import "./BigCard.vue?vue&type=style&index=0&id=faed435a&lang=scss&scoped=true"
script.__scopeId = "data-v-faed435a"

export default script